<template lang="html">
  <div id="results-page">

    <section class="breadcrumb-section">
      <div class="container med-container px-lg-0">
        <span>Home</span>
        <span class="line">/</span>
        <span>Productos</span>
      </div>
    </section>

    <section class="container med-container products-section">
      <div class="row mb-3">
        <div class="col-12 col-s-title px-lg-0">
          <h2 class="title-s1">
            <span v-if="filtersForm.keywords == 'KITS'">
              KITS (Paquetes)
            </span>
            <span v-else>
              Productos
            </span>
          </h2>
        </div>
      </div>

      <div class="row align-items-start">

        <!-- Resultados en columnas -->
        <div class="col-lg col-products">
          <div class="row sample-products-wrapper xxl-4e" v-if="!isLoading">
            <div class="col-md-6 col-lg-4 col-xl-3 sample-product shad-prod" v-for="(product, pInx) in products" :key="'pInx-'+pInx">
              <a class="outlined-box">
                <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>

                <div class="box-image">
                  <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                  <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.imageUrl+')' }">
                    <img src="public/images/pages/products/product.png" >
                  </div>
                </div>

                <div class="box-shot-descr">
                  <h6 class="brand">{{ product.sku }}</h6>
                  <h6 class="name">{{ product.name }}</h6>

                  <!-- <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h6> -->
                </div>

              </a>
            </div>

            <!-- <div class="col-12 col-pagination">
              <b-pagination-nav :link-gen="linkGen" :number-of-pages="pagination.total" use-router></b-pagination-nav>
            </div> -->
          </div>

          <div class="row">
            <div class="col-12 text-center" v-if="!products.length && !isLoading">
              <h5>No se encontraron resultados</h5>
            </div>

            <div class="col-12" v-if="isLoading">
              <LoadingComponent></LoadingComponent>
            </div>
          </div>
        </div>
        <!--  -->

      </div>

    </section>

  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {
    LoadingComponent
  },

  data(){
    return{
      isLoading: true,
      showFilters: false,
      filtersForm:{},
      products: [
        /*{
          "id": 1,
          "sku": "63423",
          "name": "Polvorin",
          "price": "75.00",
          "stock": 1,
          "imageUrl": "public/images/pages/products/product-1.jpg"
        },
        {
          "id": 2,
          "sku": "59227",
          "name": "Cuña",
          "price": "90.00",
          "stock": 3,
          "imageUrl": "public/images/pages/products/product-2.jpg",
        },
        {
          "id": 3,
          "sku": "66720",
          "name": "Erelux",
          "price": "108.00",
          "stock": 5,
          "imageUrl": "public/images/pages/products/product-3.jpg"
        },
        {
          "id": 4,
          "sku": "59223",
          "name": "Feros noche",
          "price": "90.00",
          "stock": 6,
          "imageUrl": "public/images/pages/products/product-4.jpg"
        },
        {
          "id": 5,
          "sku": "43512",
          "name": "Astragalo",
          "price": "52.20",
          "stock": 9,
          "imageUrl": "public/images/pages/products/product-5.jpg"
        },
        {
          "id": 1,
          "sku": "63423",
          "name": "Polvorin",
          "price": "75.00",
          "stock": 1,
          "imageUrl": "public/images/pages/products/product-1.jpg"
        },
        {
          "id": 2,
          "sku": "59227",
          "name": "Cuña",
          "price": "90.00",
          "stock": 3,
          "imageUrl": "public/images/pages/products/product-2.jpg",
        },
        {
          "id": 3,
          "sku": "66720",
          "name": "Erelux",
          "price": "108.00",
          "stock": 5,
          "imageUrl": "public/images/pages/products/product-3.jpg"
        },
        {
          "id": 4,
          "sku": "59223",
          "name": "Feros noche",
          "price": "90.00",
          "stock": 6,
          "imageUrl": "public/images/pages/products/product-4.jpg"
        },
        {
          "id": 5,
          "sku": "43512",
          "name": "Astragalo",
          "price": "52.20",
          "stock": 9,
          "imageUrl": "public/images/pages/products/product-5.jpg"
        },
        {
          "id": 1,
          "sku": "63423",
          "name": "Polvorin",
          "price": "75.00",
          "stock": 1,
          "imageUrl": "public/images/pages/products/product-1.jpg"
        },
        {
          "id": 2,
          "sku": "59227",
          "name": "Cuña",
          "price": "90.00",
          "stock": 3,
          "imageUrl": "public/images/pages/products/product-2.jpg",
        },*/
      ],

      
    }
  },
  watch: {
    '$route': function(newVal){
      this.initializeFilters();
      this.getProducts();
    }
  },

  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },

    onSubmitFilters(evt) {
        evt.preventDefault();

    },
    getProducts(){
        axios.post(tools.url('/api/products'),this.filtersForm).then((response)=>{
          this.products = response.data;
          setTimeout( ()=>{ this.isLoading = false; }, 200);
        }).catch((error)=>{
          
        });
    },

   
  },

  mounted(){
    this.initializeFilters();
    this.getProducts();
  },

  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },

    onSubmitFilters(evt) {
        evt.preventDefault();

    },

    initializeFilters() {
      // Limpiar filtros anteriores
      this.filtersForm = {};
      
      // Establecer keywords si existen en la query
      if(this.$route.query.keywords){
        this.filtersForm.keywords = this.$route.query.keywords;
      }
    },

    getProducts(){
        axios.post(tools.url('/api/products'),this.filtersForm).then((response)=>{
          this.products = response.data;
          setTimeout( ()=>{ this.isLoading = false; }, 200);
        }).catch((error)=>{
          
        });
    },

   
  },
}
</script>
